import {
  Button,
  Box,
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import { PaymentMethodProps, PaymentMethodsProps } from './types';
import { CreditCardIcon } from '../../utils/CreditCardIcon';
import { hoverCss, selectedCss } from '../../utils/Styles';

const DisplayData = ({
  defaultMethod,
  deleteMethod,
  method: {
    id,
    card: { brand, exp_month: month, exp_year: year, last4 }
  },
  selectedPayment
}: PaymentMethodProps) => {
  const [removeSelected, setRemovedSelected] = useState<string | undefined>(
    undefined
  );
  useEffect(() => {
    setRemovedSelected(undefined);
  }, [selectedPayment]);
  return (
    <Grid container>
      <Grid item xs={1}>
        {CreditCardIcon(brand)}
      </Grid>
      <Grid item xs={9}>
        <Typography>{`****-****-****-${last4}`}</Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography sx={{ float: 'right' }}>{`${month}/${year}`}</Typography>
      </Grid>
      {id === defaultMethod ? (
        <Grid item xs={2}>
          <Typography color="gray" variant="overline">
            DEFAULT
          </Typography>
        </Grid>
      ) : null}
      <Grid item xs={id === defaultMethod ? 10 : 12}>
        {selectedPayment === removeSelected && removeSelected === id ? (
          <Box sx={{ float: 'right' }}>
            Are you sure?
            <Button onClick={() => deleteMethod(id)}>Yes</Button>
            <Button onClick={() => setRemovedSelected(undefined)}>No</Button>
          </Box>
        ) : (
          <Button
            onClick={() => setRemovedSelected(id)}
            sx={{
              float: 'right',
              color: 'gray',
              '&:hover': {
                color: 'red'
              }
            }}
          >
            REMOVE
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export const PaymentMethods = ({
  defaultMethod,
  deleteMethod,
  paymentMethodList,
  methodOnClick,
  selectedPayment
}: PaymentMethodsProps) => (
  <>
    {paymentMethodList.map((method) => (
      <Grid item padding={2} key={`payment-method-${method.id}`}>
        <Card
          variant="outlined"
          onClick={() => methodOnClick(method.id)}
          sx={
            selectedPayment === method.id
              ? {
                  ...selectedCss,
                  ...hoverCss
                }
              : {
                  ...hoverCss
                }
          }
        >
          <CardContent>
            <DisplayData
              defaultMethod={defaultMethod}
              deleteMethod={deleteMethod}
              method={method}
              selectedPayment={selectedPayment}
            />
          </CardContent>
        </Card>
      </Grid>
    ))}
  </>
);
